import { AError } from "src/requests/types";
import { LoginDTO } from "src/requests/login/types";
import {
  LOGIN_MICROSOFT_ERROR,
  LOGIN_MICROSOFT_SUCCESS,
  REQUEST_LOGIN,
} from "../../actions";

type RequestMicrosoftLogin = {
  type: typeof REQUEST_LOGIN;
};

export const requestMicrosoftLogin = (): RequestMicrosoftLogin => ({
  type: REQUEST_LOGIN,
});

type ErrorMicrosoft = {
  type: typeof LOGIN_MICROSOFT_ERROR;
  errors: { error: AError };
};

export const errorMicrosoftLogin = (error: AError): ErrorMicrosoft => ({
  type: LOGIN_MICROSOFT_ERROR,
  errors: { error },
});

type SuccessMicrosoftLogin = {
  type: typeof LOGIN_MICROSOFT_SUCCESS;
  payload: {
    data: LoginDTO;
    isUserAdmin: boolean;
  };
};

export const successMicrosoftLogin = (
  data: LoginDTO,
  isUserAdmin: boolean
): SuccessMicrosoftLogin => ({
  type: LOGIN_MICROSOFT_SUCCESS,
  payload: { data, isUserAdmin },
});

export type MicrosoftLoginActions =
  | RequestMicrosoftLogin
  | SuccessMicrosoftLogin
  | ErrorMicrosoft;
